<template>
  <div class="container my-3">
    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i }}
        </b-alert>
      </p>
    </div>
    <p></p>

    <div>
      <div v-if="codigoNacional">
        <div style="text-align: center">
          <loading :active.sync="carregando" :is-full-page="true"></loading>
        </div>
        Nome: {{ this.informacaoContribuinte.nome }}
        <br />
        CPF: {{ this.codigoNacional }}
      </div>
      <div v-else>
        <div style="text-align: center">
          <loading :active.sync="carregando" :is-full-page="true"></loading>
        </div>
        <div>
          <!-- ABA DADOS GERAIS -->
          <form @submit.prevent>
            <h2 class="title">Emissão de DRAM de IPTU/{{ anoAtual }}</h2>
            <b-card style="background-color: rgb(163, 207, 222);">
              As informações fornecidas serão usadas somente para emissão de DRAM de IPTU/{{ anoAtual }} e deverá ser
              usada uma das seguintes opções de preenchimento:<br />
              <b>Opção 1.</b> Índice Cadastral do imóvel (seqüência de caracteres - números ou letras - que identifica seu
              imóvel no cadastro da PBH).<br />
              <b>Opção 2.</b> CPF ou CNPJ do proprietário juntamente com o CEP do imóvel.
            </b-card>
            <br />
            <b-card>
              <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Essa opção permite a emissão de DRAM do IPTU do exercício atual por meio do índice cadastral do imóvel.">
                Opção 1 - Dados do imóvel
                <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
              </span>

              <b-row class="my-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="indiceCadastral" class="pb-3">Índice Cadastral</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="indiceCadastral" class="ml-3" v-mask="mascaraIdentificador"
                    @keyup="limpaCepCodigoNacional()" @keydown="validacaoIndiceCadastral()"
                    v-model="informacaoContribuinte.indiceCadastral">
                  </b-form-input>
                  <small id="iptu" :class="erroValidacaoIptu" class="ml-3">
                    {{ mensagemValidacaoIptu }}
                  </small>
                </b-col>
              </b-row>

              <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Informar o CEP do imóvel juntamente com o CPF/CNPJ do proprietário.">
                Opção 2 - Consulta por CEP + CPF/CNPJ
                <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
              </span>

              <b-row class="my-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="cep" class="pb-3">CEP</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="cep" class="ml-3" v-model="endereco.cep" @keyup="limpaIPTU()" v-mask="['##.###-###']">
                  </b-form-input>
                  <small id="iptu" :class="erroValidacaoCep" class="ml-3">
                    {{ mensagemValidacaoCep }}
                  </small>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="logradouro" class="pb-3">Logradouro</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="logradouro" class="ml-3" readonly v-model="endereco.logradouro">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-4">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" class="mr-3" align-self="center">
                  <label for="cpf" class="pb-3">CPF/CNPJ</label>
                </b-col>
                <b-col sm="3" md="3" class="ml-05" align-self="start">
                  <b-form-input  
                    id="cpfCnpj"
                    class="ml-0"
                    v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                    style="text-transform: uppercase"
                    v-model="endereco.codigoNacional"
                    @keyup="validacaoCPFCNPJ()"
                  >
                  </b-form-input>
                  <small
                    :class="erroValidacaoCPFCNPJ"
                    class="ml-3 form-text"
                  >
                    {{ mensagemValidacaoCPFCNPJ }}
                  </small>
                </b-col>
              </b-row>

              <b-row class="mb-2 float-right">
                <b-button variant="secondary" class="float-right" @click="() => limparFormulario()">
                  Limpar
                </b-button>
                <b-button variant="primary" class="ml-3 mr-3 float-right" :disabled="verificaPreenchimento()"
                  @click.prevent="() => pesquisarIptu()">
                  Pesquisar
                </b-button>

              </b-row>
            </b-card>
          </form>
        </div>
      </div>
      <!-- exibir indices cadastrais a serem selecionados -->
      <div v-if="exibirIndicesCadastraisParaSelecionarIptu === true">
        <h2 class="title mt-5">Seleção de Índices Cadastrais</h2>
        <b-card class="mb-5">
          <div v-if="listaIndicesCadastraisParaSelecionar">
            <p>Selecione a DRAM a ser emitida:</p>

            <b-row class="text-center" align-v="center">
              <b-col>
                <b>Índice Cadastral</b>
              </b-col>
              <b-col>
                <b>Endereço</b>
              </b-col>
              <b-col>
                <b>Situação</b>
              </b-col>
              <b-col>
                <b>Ação</b>
              </b-col>
            </b-row>
            <br />
            <b-row v-for="guia in listaIndicesCadastraisParaSelecionar" :key="guia" class="text-center" align-v="center">

              <b-col>
                <p>{{ guia.AINDICECADASTRAL }}</p>
              </b-col>

              <b-col>
                <p>{{ guia.AENDERECO }}</p>
              </b-col>

              <b-col align="center">
                <b-card v-if="guia.ASITUACAOINDICE === 'ATIVO'" style="border: none;">
                  <div
                    style="background-color: #ffd700; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">EM ABERTO</p>
                  </div>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'ISENTO'" style="border: none;">
                  <div
                    style="background-color: yellowgreen; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">{{ guia.ASITUACAOINDICE }}</p>
                  </div>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'QUITADO'" style="border: none;">
                  <div
                    style="background-color: green; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">{{ guia.ASITUACAOINDICE }}</p>
                  </div>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'EM ATRASO'" style="border: none;">
                  <div
                    style="background-color: red; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">{{ guia.ASITUACAOINDICE }}</p>
                  </div>
                </b-card>
              </b-col>

              <b-col>
                <b-card v-if="guia.ASITUACAOINDICE === 'ATIVO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(guia.AURLEMISSAO)">
                    Emitir DRAM de IPTU
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'ISENTO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(urlCNDOnline)">
                    Emitir CND
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'QUITADO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(urlCNDOnline)">
                    Emitir CND
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'EM ATRASO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(guia.AURLEMISSAO)">
                    Emitir DRAM de IPTU
                  </b-button>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-card>
         <a id="ancora-selecao-indice-cadastrais"></a>
      </div>
      <!-- exibir indices cadastrais a serem selecionados-->

      <div v-if="mostrarErroMuitosLancamentos && !carregando" class="my-3">
        <h2 class="title mt-5">Informações do contribuinte</h2>
        <b-card class="mb-5">
          <b-card class="bg-primary mx-5">
            <div style="text-align: center">
              <span class="text-white font-weight-bolder">
                {{ formatCPFCNPJ(informacaoContribuinte.cadastroNacional) }}
                : {{ informacaoContribuinte.nome }}</span>
            </div>
          </b-card>
        </b-card>

        <b-alert show variant="warning">
          <b-icon variant="warning" icon="exclamation-diamond-fill" />
          Quantidade de registros superior ao limite. Favor solicitar o DRAM
          pelo e-mail <a href="mailto:gecda@pbh.gov.br">gecda@pbh.gov.br</a>
        </b-alert>
      </div>
      <div v-if="mostrarDemaisInformacoes &&
        !mostrarErroMuitosLancamentos &&
        !carregando
        ">

        <h2 class="title mt-5" v-if="mostrarDemaisInformacoes === true">
          Seleção de DRAMs
        </h2>
        <div :v-if="mensagemLancamentos" v-for="i in mensagemLancamentos" :key="i">
          <p>
            <b-alert show variant="warning">
              <div>
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                {{ i }}
              </div>
            </b-alert>
          </p>
        </div>
        <div v-if="mostrarDemaisInformacoes === true">
          <b-alert show variant="primary">
            <div>
              <b-icon variant="primary" icon="info-circle-fill" />
              Abaixo são apresentadas as DRAMs de IPTU
            </div>
          </b-alert>
        </div>

        <b-card v-if="mostrarDemaisInformacoes === true">

          <div v-if="listaGuiasIptu">
            <p>Selecione a DRAM a ser emitida:</p>

            <b-row class="text-center" align-v="center">
              <b-col>
                <b>Índice Cadastral</b>
              </b-col>
              <b-col>
                <b>Endereço</b>
              </b-col>
              <b-col>
                <b>Situação</b>
              </b-col>
              <b-col>
                <b>Ação</b>
              </b-col>
            </b-row>
            <br />
            <b-row v-for="guia in listaGuiasIptu" :key="guia" class="text-center" align-v="center">

              <b-col>
                <p>{{ guia.AINDICECADASTRAL }}</p>
              </b-col>

              <b-col>
                <p>{{ guia.AENDERECO }}</p>
              </b-col>
              <b-col align="center">
                <b-card v-if="guia.ASITUACAOINDICE === 'ATIVO'" style="border: none;">
                  <div
                    style="background-color: #ffd700; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">EM ABERTO</p>
                  </div>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'ISENTO'" style="border: none;">
                  <div
                    style="background-color: yellowgreen; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">{{ guia.ASITUACAOINDICE }}</p>
                  </div>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'QUITADO'" style="border: none;">
                  <div
                    style="background-color: green; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">{{ guia.ASITUACAOINDICE }}</p>
                  </div>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'EM ATRASO'" style="border: none;">
                  <div
                    style="background-color: red; width: 130px; height:35px; padding-top:6px; padding-bottom:2px; border-radius: 10px">
                    <p style="color:white">{{ guia.ASITUACAOINDICE }}</p>
                  </div>
                </b-card>
              </b-col>

              <b-col>
                <b-card v-if="guia.ASITUACAOINDICE === 'ATIVO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(guia.AURLEMISSAO)">
                    Emitir DRAM de IPTU
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE == 'EMITIR CND'" style="border: none;">
                  <b-button variant="primary" @click="emiteCND(guia.AURLEMISSAO)">
                    Emitir CND
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'ISENTO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(urlCNDOnline)">
                    Emitir CND
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'QUITADO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(urlCNDOnline)">
                    Emitir CND
                  </b-button>
                </b-card>
                <b-card v-if="guia.ASITUACAOINDICE === 'EM ATRASO'" style="border: none;">
                  <b-button variant="primary" @click="guiaPagamentoAVista(guia.AURLEMISSAO)">
                    Emitir DRAM de IPTU
                  </b-button>
                </b-card>
              </b-col>
            </b-row>
          </div>
          <a id="ancora-dram-iptu"></a>
        </b-card>
         
        <b-card v-if="mostrarDebitosSelecionados === true">
          <div>
            <b-form-group :value="item" v-for="(item, index) in listaLancamentos" :key="index" :name="item.DESCRICAO"
              class="mb-2">

              <template v-slot="{ ariaDescribedby }">
                <b-form-checkbox v-for="subitem in item.LISTA_NIVEL2" :key="subitem.DESCRICAO_LANCAMENTO" :value="subitem"
                  v-model="orgaoCobranca" :name="subitem.DESCRICAO + index" class="ml-3 mt-2" @change="limparDadosTabela"
                  :aria-describedby="ariaDescribedby" stacked>
                  {{ subitem.DESCRICAO }}
                </b-form-checkbox>
              </template>
            </b-form-group>
            --------------------------------------------------------------------------
            <tabelaAgrupamentos :items="listaNiveis" v-on:mostrarDebitosSelecionados="getDebitosSelecionados($event)" />
            <b-row class="mr-2 float-right">
              <b-button variant="primary" :disabled="orgaoCobranca.length === 0 ||
                bloquearExibirLancamentos === true
                " @click.prevent="habilitaSelecaoDebitos()">
                Exibir débitos
              </b-button>
            </b-row>
          </div>
        </b-card>
        <!--  -->

        <!-- exibir debitos -->
        <div v-if="bloquearExibirLancamentos === true || exibirDebitos === true">
          <h2 class="title mt-5">Débitos</h2>
          <b-card class="mb-5">
            <tabela :items="lancamentos" :fields="cabecalhoLancamento" :selecionados="lancamentosSelecionados"
              title="lancamentos" v-on:mostrarSelecionados="getSelecionados($event)" />

            <b-row class="mt-3 float-right">
              <b-button class="my-3 mr-2" variant="secondary" @click="retornaSelecaoDebitos()">
                Voltar
              </b-button>

              <div class="my-3 mr-3">
                <b-button :disabled="lancamentosSelecionados.length <= 0" id="popover-reactive-1" variant="primary"
                  ref="button">
                  Confirmar Seleção
                </b-button>
                <b-popover target="popover-reactive-1" triggers="click" :show.sync="popoverShow" placement="auto"
                  container="my-container" ref="popover">
                  <template #title>
                    <b-button @click="onClose" class="close" aria-label="Close">
                      <span class="d-inline-block" aria-hidden="true">&times;</span>
                    </b-button>
                    Confirma
                  </template>

                  <div>
                    <h5 class="title mt-1">
                      Tem certeza que deseja confirmar a seleção dos lançamentos
                      ?
                    </h5>
                    <hr />
                    <b-row>
                      <b-col sm="1" md="2"> </b-col>
                      <b-col>
                        <b-button @click="onClose" size="sm" variant="danger">Não</b-button>
                      </b-col>
                      <b-col>
                        <b-button @click="onOk" size="sm" variant="primary">Sim</b-button>
                      </b-col>
                    </b-row>
                  </div>
                </b-popover>
              </div>
            </b-row>
          </b-card>
        </div>

        <!-- debitos selecionados-->
        <div v-if="exibirDebitosSelecionados === true">
          <h2 class="title mt-5">Débitos selecionados</h2>
          <b-card class="mb-5">
            <tabelaDebitosSelecionados :items="debitosSelecionados" :fields="cabecalhoDebitosSelecionados" />

            <b-row class="mt-3 float-right">
              <b-button class="my-3 mr-4" variant="secondary" @click="fecharDebitosSelecionados()">
                Fechar
              </b-button>
            </b-row>
          </b-card>
        </div>

        <!-- lançamentos selecionados -->
        <div v-if="verLancamentos === true">
          <h2 class="title mt-5">Seleção de Lançamentos</h2>
          <b-card class="mb-5">
            <b-row>
              <b-col lg="6" md="4">
                <span class="title h5 mr-2" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                  title="dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır.">
                  Relação de lançamentos selecionados para emissão de DRAM
                  <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
                </span>
              </b-col>
              <b-col lg="3"> </b-col>
              <b-col lg="3">
                <b-button class="my-2 mr-1 float-right" variant="primary" @click="habilitaSelecaoDebitos()">
                  Selecionar novos lançamentos
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-1 center">
              <b-col lg="4"> </b-col>
              <b-col lg="4">
                <b-button variant="link"  @click.prevent="mostrarDebitosSelecionados()">
                  <h3 class="title mt-5">Ver lançamentos selecionados</h3>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <!-- forma de pagamento -->
        <div v-if="exibirFormaPagamento === true">
          <h2 class="title mt-5">Selecione a forma de pagamento</h2>
          <b-card class="mb-3">
            <b-row class="mb-3 center">
              <b-col lg="4"> </b-col>
              <b-col lg="2">
                <b-button class="botao mt-3" variant="primary"  size="lg" @click.prevent="pagarVista()">
                  Pagamento integral ou parcial
                </b-button>
              </b-col>
              <b-col lg="1">
                <b-button class="mt-3 botao" variant="secondary" @click.prevent="parcelar()">
                  Parcelar
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
      <div class="mt-5" v-else>
        <div :v-if="mensagemLancamentos" v-for="i in mensagemLancamentos" :key="i">
          <p>
            <b-alert show variant="warning">
              <b-icon variant="warning" icon="exclamation-diamond-fill" />
              {{ i }}
            </b-alert>
          </p>
        </div>
      </div>

      <!-- lista guias a vista-->
      <div v-if="exibirListaGuia === true">
        <h2 class="title mt-5">Relação de DRAM para pagamento à vista</h2>
        <b-card class="mt-3">
          <tabelaGuiasVista :items="calculos" :fields="cabecalhoGuias" />
          <b-row class="mt-3 float-right">
            <b-button class="my-3 mr-4" variant="secondary" @click="exibirListaGuia = false">
              Voltar
            </b-button>
            <b-button variant="success" class="my-3 mr-3 float-right" size="sm" :disabled="calculos === ''
              " @click.prevent="() => emitirGuiasVista()">
              Emitir DRAM(s)
            </b-button>
          </b-row>
        </b-card>
      </div>
      <!-- lista guias a vista -->

      <!-- lista guias parcelado -->
      <div v-if="exibirListaGuiaParcelar === true">
        <h2 class="title mt-5">Seleção de parcelas para cada tipo de DRAM</h2>
        <b-card class="mb-3">
          <div v-for="(descricao, index) in opcoesParcelamento" :key="index">
            <h5 class="title mb-3">
              {{ descricao.descricao_grupo }}
              <b-card class="mt-3">
                <div>
                  <b-form-select v-model="opcaoParcelaSelecionada">
                    <template slot="first">
                      <option :value="null" disabled>
                        -- Selecione uma opção --
                      </option>
                    </template>
                    <option v-for="(valor, index1) in descricao.lista_opcao_parcto"
                      v-bind:value="valor.AIdFaixasRegraParcelamento" :key="index1">
                      {{ formatCurrency(valor.AVlrDepositoInicial) }} +
                      {{ valor.AQtdParcela }} parcela(s) de {{ formatCurrency(valor.AVlrParcela) }}
                    </option>
                    <div class="mt-3">
                      opcaoParcelaSelecionada:
                      <strong>{{ opcaoParcelaSelecionada }}</strong>
                    </div>
                  </b-form-select>
                </div>
                <b-row class="mb-2 mt-3 float-right">

                </b-row>
              </b-card>
            </h5>
          </div>
          <b-row class="mt-3 float-right">
            <b-button class="my-3 mr-4" variant="secondary" @click="fecharGuiasParcelar()">
              Voltar
            </b-button>
            <b-button variant="success" class="my-3 mr-3 " size="sm" :disabled="opcaoParcelaSelecionada === null
              " @click.prevent="abrirModal('modal-EmissaoGuia')">
              Emitir DRAM
            </b-button>
          </b-row>
        </b-card>
      </div>
      <!-- lista guias parcelado -->

      <b-card class="mt-3" v-if="calculos.RESUMO_CALCULO">
        <div>
          <div class="d-flex justify-content-around mt-3">
            <b-button class="mt-2 botao" variant="primary" size="lg" :disabled="bloqueioEmissaoGuia"
              @click.prevent="abrirDialogPagamentoAVista()">
              Pagamento integral ou parcial
            </b-button>

            <b-button class="mt-2 botao" variant="secondary" :disabled="bloqueioEmissaoGuia"
              @click.prevent="abrirDialogParcelamento()">
              Parcelar
            </b-button>

            <b-button class="mt-2" variant="secondary" @click.stop="simularPagamento">
              Simulação
            </b-button>
          </div>
        </div>
      </b-card>

      <b-modal ref="dialog-confirmar-selecao" hide-footer title="Confirmar" size="sm" modal-class="small-modal" centered>
        <p>
          Não foram selecionados todos os débitos do tipo "{{
            orgaoCobranca.DESCRICAO
          }}" para esta emissão. Você deseja prosseguir com esta seleção?
        </p>

        <b-button-group class="w-100">
          <b-button colspan="6" variant="outline-secondary "
            @click="fecharModal('dialog-confirmar-a-vista')">Não</b-button>
          <b-button colspan="6" class="ml-3" variant="primary" @click="
            abrirModalPagamentoAVistaSeNecessario('modal-pagamento-a-vista')
            ">Sim</b-button>
        </b-button-group>
      </b-modal>

      <b-modal ref="modal-pagamento-a-vista" hide-footer title="Pagar à Vista" size="xl" modal-class="small-modal">
        <div v-if="calculos.TLISTAURLGUIA">
          <p>Selecione a DRAM a ser emitida:</p>
          <b-row v-for="guia in calculos.TLISTAURLGUIA" :key="guia" class="text-center" align-v="center">
            <b-col>
              <b-button variant="primary" @click="guiaPagamentoAVista(guia.URLEMISSAO)">
                {{ guia.DESCRICAO }}
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAMs para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert>
        </div>
      </b-modal>

      <b-modal ref="modal-guias-parcelamento" hide-footer title="DRAM do parcelamento" size="xl"
        modal-class="small-modal">
        <div v-if="listaGuiasParcelamento">
          <p>Selecione a DRAM a ser emitida:</p>
          <b-row v-for="guia in listaGuiasParcelamento" :key="guia" class="text-center" align-v="center">
            <b-col>
              <b-button variant="primary" @click="guiaPagamentoAVista(guia.URLEMISSAO)">
                {{ guia.DESCRICAO }}
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAMs para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert>
        </div>
      </b-modal>

      <b-modal ref="modal-confirmar-parcelamento" hide-footer title="Seleção de Parcelamentos" size="xl"
        modal-class="small-modal">
        <div v-if="calculos.OPCOES_PARCTO_CESSAO || calculos.OPCOES_PARCTO_DEMAIS">
          <p>
            Para o parcelamento deverão ser emitidas dois DRAM, uma para cada
            opção abaixo:
          </p>
          <b-row class="text-center" align-v="center">
            <b-col v-if="calculos.OPCOES_PARCTO_CESSAO">
              <b-button variant="primary" @click="abrirModalParcelamentoSeNecessario('cessao')">
                DRAM de Lançamentos Cedidos
              </b-button>
            </b-col>

            <b-col v-if="calculos.OPCOES_PARCTO_DEMAIS">
              <b-button variant="primary" @click="abrirModalParcelamentoSeNecessario('demais')">
                DRAM Demais Lançamentos
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAM para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert>
        </div>
      </b-modal>

      <b-modal ref="modal-selecao-parcelamento" hide-footer title="Seleção de Parcelamentos" size="xl"
        modal-class="small-modal">
        <div v-if="this.opcoesParcto">
          <p>Selecione uma das opções:</p>

          <b-row v-for="opcao in opcoesParcto" :key="opcao" class="text-center" align-v="center">
            <b-col>
              <b-button variant="primary" @click="abrirModalParcelamento(opcao)">
                {{ opcao.DESCRICAO_GRUPO }}
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAM para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert>
        </div>
      </b-modal>

      <b-modal ref="modal-parcelamento" hide-footer title="Parcelamento" size="xl" @hide="limparCamposParcelamento()">
        <div v-if="this.opcaoParctoSelecionada.LISTA_OPCAO_PARCTO">
          <p>Selecione abaixo uma das opções de parcelamento</p>
          <div class="mb-3">
            <h5>Opções de parcelamento</h5>
            <b-form-select id="opcoesParcelamentoInternas" v-model="escolhaOpcaoParcelamentoInterna"
              :options="listaOpcoesParcelamentoInternas" />
          </div>

          <h4 class="mt-5">Contato</h4>
          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="telefoneCelular">Telefone Celular</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input id="telefoneCelular" placeholder="(31)99999-9999" v-mask="['(##)#####-####']"
                v-model="informacaoParcelamento.telefone">
              </b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="email">Email</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input type="email" id="email" placeholder="exemplo@exemplo.com.br"
                v-model="informacaoParcelamento.email">
              </b-form-input>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button variant="primary" :disabled="escolhaOpcaoParcelamentoInterna === '' ||
              (informacaoParcelamento.email.length < 6 &&
                !informacaoParcelamento.email.includes('@') &&
                informacaoParcelamento.telefone.length < 14)
              " @click.prevent="emitirGuiaParcelamento">
              Emitir DRAM</b-button>
          </div>
        </div>
        <div v-else>
          <b-alert show variant="danger"><b-icon variant="danger" icon="x-circle-fill" />Erro ao gerar os
            parcelamentos, favor verificar com o Administrator do
            sistema.</b-alert>
        </div>
      </b-modal>

      <b-modal ref="modal-EmissaoGuia" hide-footer title="Confirmar emissão de DRAMs" size="xl"
        @show="confirmarEmissaoGuia()" @hide="limparCamposEmissaoGuia()">
        <div :v-if="mensagemEmissaoGuiaSucesso" v-for="i in mensagemEmissaoGuiaSucesso" :key="i">
          <p>
            <b-alert show variant="success" dismissible>
              <b-icon variant="success" icon="check2" />
              {{ i }}
            </b-alert>
          </p>
        </div>

        <h5>
          Preencha o dados abaixo para confirmar a emissão
        </h5>

        <b-row class="my-3">
          <b-col sm="2" align-self="end">
            <label for="cadastroNacional">CPF/CNPJ</label><span class="ml-1" style="color: red">*</span>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input id="cadastroNacional" v-mask="['###.###.###-##', '##.###.###/####-##']"
              @keydown="validacaoCPFCNPJ()" v-model="informacoesEmissaoGuia.cpfCnpj">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col sm="2" align-self="end">
            <label for="razaoSocial">Nome/Razão Social</label>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input id="razaoSocial" disabled="disabled" v-model="informacoesEmissaoGuia.razaoSocial">
            </b-form-input>
          </b-col>
        </b-row>

        <h5>Contato</h5>
        <b-row class="mb-3">
          <b-col sm="2" align-self="end">
            <label for="telefone">Telefone Celular</label>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input id="telefone" v-mask="['(##)####-####', '(##)#####-####']" placeholder="(31)99999-9999"
              v-model="informacoesEmissaoGuia.telefoneCelular">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col sm="2" align-self="end">
            <label for="email">Email</label>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input id="email" type="email" v-model="informacoesEmissaoGuia.email"
              placeholder="exemplo@exemplo.com.br">
            </b-form-input>
          </b-col>
        </b-row>

        <b-card v-if="informacoesEmissaoGuia.telefoneEnviado ||
          informacoesEmissaoGuia.emailEnviado
          " class="bg-secondary mt-5 mb-3 w-50 mx-auto">
          <div style="text-align: center">
            <span class="font-weight-bolder text-white">
              Preencha o código recebido para confirmar o EmissaoGuia
            </span>
            <b-form-input id="cancelarParcelamento" v-model="informacoesEmissaoGuia.codigoEmissaoGuia" />
          </div>
        </b-card>

        <div v-if="informacoesEmissaoGuia.email &&
          informacoesEmissaoGuia.emailEnviado
          ">
          <b-alert show variant="warning">
            <b-icon variant="warning" icon="exclamation-diamond-fill" />
            Foi enviada uma mensagem para o e-mail
            {{ informacoesEmissaoGuia.email }} com um código de confirmação. É
            obrigatório o preenchimento para dar continuidade no EmissaoGuia do
            parcelamento. Favor verificar se a mensagem foi recebida!</b-alert>
        </div>

        <div v-if="informacoesEmissaoGuia.telefoneCelular &&
          informacoesEmissaoGuia.telefoneEnviado
          ">
          <b-alert show variant="warning">
            <b-icon variant="warning" icon="exclamation-diamond-fill" />
            Foi enviada uma mensagem para o número
            {{ informacoesEmissaoGuia.telefoneCelular }} com um código de
            confirmação. É obrigatório o preenchimento para dar continuidade no
            EmissaoGuia do parcelamento. Favor verificar se a mensagem foi
            recebida!
          </b-alert>
        </div>

        <b-row v-if="!mostrarConfirmacaoEmissaoGuia" class="float-right">
          <b-button variant="primary" class="mr-3" @click="enviarMensagemEmissaoGuiaParcelamento()" :disabled="informacoesEmissaoGuia.cpfCnpj.length < 11 ||
            informacoesEmissaoGuia.telefoneCelular.length < 14
            ">
            Enviar SMS
          </b-button>

          <b-button variant="primary" class="mr-3" @click="enviarEmailEmissaoGuiaParcelamento()" :disabled="informacoesEmissaoGuia.cpfCnpj.length < 11 ||
            (informacoesEmissaoGuia.email.length < 6 &&
              !informacoesEmissaoGuia.email.includes('@'))
            ">
            Enviar E-mail
          </b-button>
        </b-row>

        <b-row v-else class="float-right">
          <b-button variant="secondary" class="mr-3" @click="enviarMensagemEmissaoGuiaParcelamento()"
            :disabled="informacoesEmissaoGuia.telefoneCelular.length < 14">
            Reenviar SMS
          </b-button>

          <b-button variant="secondary" class="mr-3" @click="enviarEmailEmissaoGuiaParcelamento()" :disabled="informacoesEmissaoGuia.email.length < 6 &&
            !informacoesEmissaoGuia.email.includes('@')
            ">Reenviar E-mail</b-button>

          <b-button variant="primary" class="mr-3" @click="finalizarEmissaoGuia()"
            :disabled="informacoesEmissaoGuia.codigoEmissaoGuia.length <= 5">
            Confirmar Emissao DRAM
          </b-button>
        </b-row>
      </b-modal>

      <b-modal ref="dialog-confirmar-parcelamento" hide-footer title="Confirmação de parcelamento" size="xs"
        modal-class="small-modal" centered>
        <p>
          Não foram selecionados todos os débitos do tipo "{{
            orgaoCobranca.DESCRICAO
          }}" para esta emissão. Você deseja prosseguir com esta seleção?
        </p>

        <b-button-group class="w-100">
          <b-button colspan="6" variant="outline-secondary "
            @click="fecharModal('dialog-confirmar-parcelamento')">Não</b-button>
          <b-button colspan="6" class="ml-3" variant="primary" @click="mostrarModalParcelamento()">Sim</b-button>
        </b-button-group>
      </b-modal>

      <b-modal ref="dialog-confirmar-a-vista" hide-footer title="Confirmação de pagamento à vista" size="sm"
        modal-class="small-modal" centered>
        <p>
          Não foram selecionados todos os débitos do tipo "{{
            orgaoCobranca.DESCRICAO
          }}" para esta emissão. Você deseja prosseguir com esta seleção?
        </p>

        <b-button-group class="w-100">
          <b-button colspan="6" variant="outline-secondary "
            @click="fecharModal('dialog-confirmar-a-vista')">Não</b-button>
          <b-button colspan="6" class="ml-3" variant="primary" @click="
            abrirModalPagamentoAVistaSeNecessario('modal-pagamento-a-vista')
            ">Sim</b-button>
        </b-button-group>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import constantes from "../constants/index";
import Tabela from "../components/tabelaDebitosGrupo.vue";
import tabelaDebitosSelecionados from "../components/tabelaDebitosSelecionados.vue";
import tabelaGuiasVista from "../components/tabelaGuiasVista.vue";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
import { posicionaPagina } from "../utils/posicionaPagina";
import { validarCPF, validarCNPJ } from '@at-siatu-tributario/tipo-identificador';

import moment from "moment";

export default {
  components: {
    loading,
    Tabela,
    tabelaDebitosSelecionados,
    tabelaGuiasVista,
  },
  directives: {
    mask,
  },
  data() {
    return {
      carregando: false,
      mascaraIdentificador: {},

      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        J: {
          pattern: /[0-9xX]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        E: {
          pattern: /[A-Za-z0-9 ]/,
          transform: function (v) {
            if (v.match(/\d/)) return " " + v;
            else return v.toLocaleUpperCase();
          },
        },
        X: {
          pattern: /[A-Za-z0-9]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        "#": { pattern: /\d/ },
      },

      opcaoCpfCnpjSelecionada: 'CPF',
      options: [
        { item: 'CPF', name: 'CPF' },
        { item: 'CNPJ', name: 'CNPJ' },
      ],
      mostrarInputCpfCnpj: true, 

      itemsGrupo: [],

      origem: "",
      origemAcesso: "",
      userName: "",      

      opcaoParcelaSelecionada: null,
      selected: [],
      allSelected: false,
      indeterminate: false,

      selectAllRows: false,
      rowsPerPage: 10,
      pageSizeMenu: [10, 20, 50, 100, 200],
      currentPage: 1,

      preencheCpfCnpjOK: false,
      preencheIptuOK: false,
      preencheCepOK: false,

      mensagem: "",
      mensagemSucesso: [],
      mensagemErro: [],
      mostrarSelecaoLancamentos: false,
      mostrarSelecaoDebitos: false,
      mensagemLancamentos: [],
      mensagemParcelamento: [],
      mensagemEmissaoGuia: [],
      mensagemEmissaoGuiaSucesso: [],

      mensagemValidacaoIptu: "",
      erroValidacaoIptu: "",
      mensagemValidacaoCPFCNPJ: "",
      erroValidacaoCPFCNPJ: "",
      mensagemValidacaoCep: "",
      erroValidacaoCep: "",

      mensagemValidacaoIdentificador: "",
      erroValidacaoIdentificador: "",

      mensagemValidacaoParcelamento: "",
      erroValidacaoParcelamento: "",

      mensagemValidacaoCodigoParcelamento: "",
      erroValidacaoCodigoParcelamento: "",

      mensagemValidacaoPlacaVeiculo: "",
      erroValidacaoPlacaVeiculo: "",

      mensagemValidacaoLancamento: "",
      erroValidacaoLancamento: "",

      desabilitacodigoNacional: true,
      desabilitaIdentificador: false,
      desabilitaParcelamento: false,
      desabilitanomeContribuinte: true,

      opcoesIdentificador: [],
      opcoesParcelar: [],

      dadosContribuinte: {
        cadastroNacional: "",
        cpf: "",
        nomeContribuinte: "",
        cnpj: "",
        tipoIdentificador: "",
        identificador: "",
        numeroParcelamento: "",
        placaVeiculo: "",
        codigoLancamento: "",
        indiceCadastral: "",
      },

      endereco: {
        cep: "",
        tipologradouro: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        codigoNacional: "",
      },

      mostrarDemaisInformacoes: false,
      mostrarErroMuitosLancamentos: false,
      informacaoContribuinte: {
        cadastroNacional: "",
        nome: "",
        idPessoa: null,
        idPessoaPapel: null,
        idParcelamento: null,
        codigoLancamento: "",
        placaVeiculo: "",
        indiceCadastral: "",
        usuario: "",
      },

      lancamentosSelecionados: [],
      debitosSelecionados: [],
      demaisParcelamento: [],
      parcelamentoCessao: [],
      listaIndicesCadastrais: [],
      listaIndicesCadastraisParaSelecionar: [],
      listaIndicesCadastraisSelecionados: [],
      codigoNacional: "",
      urlCNDOnline: "http://cndonline.siatu.pbh.gov.br",


      listaGuias: [],
      bloquearExibirLancamentos: false,
      verLancamentos: false,
      exibirDebitos: false,
      exibirDebitosSelecionados: false,
      exibirFormaPagamento: false,
      exibirListaGuia: false,
      exibirListaGuiaParcelar: false,
      exibeBotaoPesquisar: false,
      exibirIndicesCadastraisParaSelecionarIptu: false,

      cadastroNacional: "",

      selecionarTodosLancamentos: false,
      cabecalhoIndicesCadastrais: [
        { label: "", key: "selected" },
        {
          label: "Índice Cadastral",
          key: "AINDICECADASTRAL",
        },
        {
          label: "Endereço",
          key: "AENDERECO"
        },
      ],

      cabecalhoDebitosSelecionados: [
        {
          label: "Descrição Débito",
          key: "DESCRICAO_LANCAMENTO",
        },
        { label: "Identificador", key: "IDENTIFICADOR" },
        {
          label: "Lançamento",
          key: "CODIGO_LANCAMENTO",
        },
        {
          label: "Situação",
          key: "ESTADO_LANCAMENTO",
        },
        {
          label: "Inscrito",
          key: "IND_INSCRICAO",
        },
        {
          label: "Valor Corrigido",
          key: "VALOR_CORRIGIDO",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor Multa",
          key: "VALOR_MULTA",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          label: "Valor Juros",
          key: "VALOR_JUROS",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          label: "Valor Honorário",
          key: "VALOR_HONORARIO",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          label: "Valor Desconto",
          key: "DESCONTOS", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à Vista ",
          key: "PAGAMENTO_VISTA", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
      ],

      items: [],
      fields: [],
      cabecalhoGuias: [
        {
          label: "Descrição",
          key: "DESCRICAO",
        },
        { label: "Numero da DRAM", key: "NUMEROGUIA" },
        {
          label: "Vencimento",
          key: "DATAVENCIMENTO",
          formatter: this.formatDateTime,
        },
        {
          label: "Valor total",
          key: "VALORTOTAL",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
        {
          label: "",
          key: "URLEMISSAO",
        },
      ],

      cabecalhoGuiasParcelado: [
        {
          label: "Descrição",
          key: "adescricao",
        },
        {
          label: "APercDepositoInicial",
          key: "APercDepositoInicial",
          formatter: this.formatCurrency,
        },

        {
          label: "AVlrDepositoInicial",
          key: "AVlrDepositoInicial",
          formatter: this.formatCurrency,
        },

        {
          label: "AQtdParcela",
          key: "AQtdParcela",
          formatter: this.formatCurrency,
        },
        {
          label: "AQtdParcelaHonorario",
          key: "AQtdParcelaHonorario",
          formatter: this.formatCurrency,
        },

        {
          label: "AVlrParcela",
          key: "AVlrParcela",
          formatter: this.formatCurrency,
        },

        {
          label: "AVlrParcelaHonorario",
          key: "AVlrParcelaHonorario",
          formatter: this.formatCurrency,
        },

        {
          label: "AVlrdesconto",
          key: "AVlrdesconto",
          formatter: this.formatCurrency,
        },

        {
          label: "AIdTipoParcelamento",
          key: "AIdTipoParcelamento",
          formatter: this.formatCurrency,
        },

        {
          label: "AIdRegraParcelamento",
          key: "AIdRegraParcelamento",
          formatter: this.formatCurrency,
        },

        {
          label: "AIdFaixasRegraParcelamento",
          key: "AIdFaixasRegraParcelamento",
          formatter: this.formatCurrency,
        },
      ],

      listaDemaisParcelamentos: [],
      escolhaDemaisParcelamentos: "",

      listaCessao: [],
      escolhaCessao: "",

      cabecalhoEmissaoGuia: [
        {
          label: "Número do Parcelamento",
          key: "NROPARCELAMENTO",
        },
        {
          label: "Quantidade de Parcelas",
          key: "QTDPARCELAS",
        },
        {
          label: "Quantidade de Parcelas em Aberto",
          key: "QTDPARCELASABERTAS",
        },
        {
          label: "Saldo Atualizado",
          key: "VALORATUALIZADO",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à vista com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
      ],

      opcoesOrgaosCobranca: [],
      orgaoCobranca: [],
      orgao: [],
      listaAgrupamentos: [],
      listaNiveis: [],

      lancamentos: [],
      carregandoTabelaLancamentos: false,

      calculos: {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      },

      calculosNovo: [],
      opcoesParcelamento: [],

      mostrarCessao: false,
      mostrarDemais: false,

      permitirCancelar: false,
      bloqueioEmissaoGuia: false,
      lancamentosEmissaoGuia: [],

      popoverShow: false,

      proibidos: [
        "09661758000145",
        "09648037000103",
        "21388632000144",
        "09674784000108",
        "09647973000191",
        "02939448000109",
        "17155730000164",
        "71395362000177",
        "16667693000100",
        "17211202000185",
        "19160696000141",
        "01823576000200",
        "03190167000150",
        "22750673000100",
        "00489828001399",
        "00102865604",
      ],

      informacoesEmissaoGuia: {
        cpfCnpj: "",
        razaoSocial: "",
        telefoneCelular: "",
        email: "",
        codigoEmissaoGuia: "",
        confirmacao: "",
        emailEnviado: false,
        telefoneEnviado: false,
        listaParcelamento: [],
        dadosExibicao: [],
      },

      tokenEmissaoGuia: "",
      mostrarConfirmacaoEmissaoGuia: false,

      informacaoParcelamento: {
        telefone: "",
        email: "",
      },

      listaGuiasParcelamento: [],
      listaOpcoesParcelamentoInternas: [],
      opcoesParcto: [],
      opcaoParctoSelecionada: "",
      escolhaOpcaoParcelamentoInterna: "",
      listaGuiasIptu: [],
    };
  },
  methods: {
    validacaoCPFCNPJ: function () {
      this.informacaoContribuinte.indiceCadastral = "";
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.endereco.codigoNacional.length;

      this.preencheCpfCnpjOK = false;

      //CPF
      if (tipo <= 14) {
        tamCampo = 14;
        txt = "CPF";
      } else {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }

      if (this.endereco.codigoNacional.length <= tamCampo) {
        this.mensagemValidacaoCPFCNPJ = txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCpfCnpjOK = false;
      }
      if (tipo == 14) {
        if (validarCPF(this.endereco.codigoNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      // cnpj
      else if (tipo == 18) {
        if (validarCNPJ(this.endereco.codigoNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      this.habilitaDesabilitaCnpjCpf = this.preencheCpfCnpjOK;
      this.erroValidacaoCPFCNPJ = formato;

      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.endereco.codigoNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    validarCNPJ(valor) {
      return validarCNPJ(valor);
    },

    validarCPF(valor) {
      return validarCPF(valor);
    },
    
    focusInput(id) {
      this.$nextTick(() => document.getElementById(id)?.focus());
    },

    validarDocumento(valor) {
      const { tipo, tamanho, validar } = this.configuracaoDocumento;
      if (!valor) {
        this.mensagemValidacaoCPFCNPJ = "";
        this.preencheCpfCnpjOK = false;
        return;
      }

      if (valor.length < tamanho) {
        this.mensagemValidacaoCPFCNPJ = `${tipo} digitado está incompleto`;
        this.erroValidacaoCPFCNPJ = "text-danger";
        this.preencheCpfCnpjOK = false;
        return;
      }

      if (validar(valor)) {
        this.mensagemValidacaoCPFCNPJ = `${tipo} digitado é válido`;
        this.erroValidacaoCPFCNPJ = "text-success";
        this.preencheCpfCnpjOK = true;
      } else {
        this.mensagemValidacaoCPFCNPJ = `${tipo} - dígito verificador inválido`;
        this.erroValidacaoCPFCNPJ = "text-danger";
        this.preencheCpfCnpjOK = false;
      }
    },

    pesquisar: async function () {
      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.orgaoCobranca = [];
      this.carregando = true;
      this.novaPesquisa = "S";

      this.mensagemErro = [];
      this.mostrarErroMuitosLancamentos = false;
      this.bloquearExibirLancamentos = false;

      this.limparMensagensDeErro();

      if (
        this.dadosContribuinte.identificador === "" &&
        this.dadosContribuinte.numeroParcelamento === "" &&
        this.dadosContribuinte.placaVeiculo === ""
      ) {
        this.endereco.codigoNacional = this.dadosContribuinte.cpf;
      }

      // PLACA DE VEICULO)
      if (this.dadosContribuinte.tipoIdentificador === 10) {
        this.dadosContribuinte.placaVeiculo =
          this.dadosContribuinte.identificador;
      }

      // CNPJ
      if (this.dadosContribuinte.tipoIdentificador === 4) {
        this.endereco.codigoNacional =
          this.dadosContribuinte.identificador;
      }

      // PARCELAMENTO
      if (this.dadosContribuinte.tipoIdentificador === 14) {
        this.dadosContribuinte.numeroParcelamento =
          this.dadosContribuinte.identificador;
      }

      // transforma os campos em númericos
      this.dadosContribuinte.tipoIdentificador = this.dadosContribuinte.tipoIdentificador || null;

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarContribuinte, {
          dadosContribuinte: this.dadosContribuinte,
        })
        .then((response) => {
          const retorno = response.data;

          const informacaoContribuinte = retorno[0];

          if (informacaoContribuinte.MENSAGEM_RETORNO === "OK") {
            posicionaPagina("#ancora-dram-iptu");
            this.mostrarDemaisInformacoes = true;

            this.informacaoContribuinte.nome = informacaoContribuinte.NOME;
            this.dadosContribuinte.nomeContribuinte = informacaoContribuinte.NOME;
            this.informacaoContribuinte.cadastroNacional =
              informacaoContribuinte.CODIGO_NACIONAL;
            this.informacaoContribuinte.idPessoa =
              informacaoContribuinte.ID_PESSOA;
            this.informacaoContribuinte.idPessoaPapel =
              informacaoContribuinte.ID_PESSOA_PAPEL;
            this.informacaoContribuinte.idParcelamento =
              informacaoContribuinte.ID_PARCELAMENTO;
            this.informacaoContribuinte.codigoLancamento =
              this.dadosContribuinte.codigoLancamento;
            this.informacaoContribuinte.placaVeiculo =
              this.dadosContribuinte.placaVeiculo;

            this.informacaoContribuinte.usuario = this.origem;

            let cpfCnpj = "";

            if (this.endereco.codigoNacional != "")
              cpfCnpj = this.endereco.codigoNacional.replace(
                /[^\d]+/g,
                ""
              );

            if (this.informacaoContribuinte.idParcelamento) {
              this.abreGuiaParcelamento();
            } else {
              if (!this.proibidos.includes(cpfCnpj)) {
                this.lancamentosAgrupados();
              } else {
                this.carregando = false;
                this.mostrarErroMuitosLancamentos = true;
              }
            }
          } else {
            this.calculos = {
              OPCOES_PARCTO_CESSAO: [],
              OPCOES_PARCTO_DEMAIS: [],
              LANCAMENTO_CESSAO: [],
              LANCAMENTO_DEMAIS: [],
            };

            this.informacaoContribuinte = {};

            this.mostrarDemaisInformacoes = false;
            this.mostrarSelecaoLancamentos = false;
            this.mostrarSelecaoDebitos = false;
            this.mostrarErroMuitosLancamentos = false;

            this.orgaoCobranca = [];
            this.carregando = true;

            this.mensagemErro = [];
            this.mensagemErro.push(informacaoContribuinte.MENSAGEM_RETORNO);
            this.carregando = false;
          }
        })
        .catch((err) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });

    },

    abreGuiaParcelamento: async function () {
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaGuiaParcelamento, {
          idParcelamento: this.informacaoContribuinte.idParcelamento,
          usuario: this.userName,          
        })
        .then((response) => {
          this.listaGuiasParcelamento = [];
          const retorno = response.data;
          const objetoGuiasParcelamento = retorno[0];

          if (objetoGuiasParcelamento.AMENSAGEM_RETORNO === "OK") {
            this.listaGuiasParcelamento = objetoGuiasParcelamento.ALISTA;
            this.carregando = false;
            this.$refs["modal-guias-parcelamento"].show();
          } else {
            this.carregando = false;
            this.mensagemErro.push(
              "Erro ao recuperar as DRAMs referentes ao parcelamento informado."
            );
            window.scrollTo(0, 0);
          }
        })
        .catch((err) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    lancamentosAgrupados: async function () {
      this.carregandoTabelaLancamentos = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.mensagemErro = [];
      this.listaGuiasIptu = [];
      this.carregando = true;

      this.informacaoContribuinte.usuario = this.origem;

      this.informacaoContribuinte.idPessoa = this.informacaoContribuinte.idPessoa || null;
      this.informacaoContribuinte.idPessoaPapel = this.informacaoContribuinte.idPessoaPapel || null;
      this.informacaoContribuinte.idParcelamento = this.informacaoContribuinte.idParcelamento || null;

      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaLancamentosIptu, {
          informacaoContribuinte: this.informacaoContribuinte,
        })
        .then((response) => {
          const retorno = response.data;

          const listaLancamentos = retorno[0];
          if (listaLancamentos === null || listaLancamentos.length < 1) {
            this.mensagemErro.push("Não foram encontradas DRAM's de IPTU para o índice cadastral informado.")
          }
          else {
            this.listaGuiasIptu = listaLancamentos;
            this.verificaGuiaUnica(this.listaGuiasIptu);
            this.mostrarDemaisInformacoes = true;
            posicionaPagina("#ancora-dram-iptu");
          }

          if (listaLancamentos.MENSAGEM_RETORNO === "OK") {
            this.mostrarSelecaoLancamentos = true;
            this.mostrarSelecaoDebitos = true;
            this.listaAgrupamentos = [];

            const lancamentos = [];

            listaLancamentos.LISTA_AGRUPAMENTO.map((lancamento) =>
              lancamentos.push(lancamento)
            );

            this.listaAgrupamentos = lancamentos;

            this.listaNiveis = this.montaAgrupamento(lancamentos);
          }

          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    lancamentosAgrupadosLogadoGov: async function () {
      this.carregandoTabelaLancamentos = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.mensagemErro = [];
      this.listaGuiasIptu = [];
      this.carregando = true;

      this.informacaoContribuinte.usuario = this.origem;

      this.informacaoContribuinte.idPessoa = this.informacaoContribuinte.idPessoa || null;
      this.informacaoContribuinte.idPessoaPapel = this.informacaoContribuinte.idPessoaPapel || null;
      this.informacaoContribuinte.idParcelamento = this.informacaoContribuinte.idParcelamento || null;

      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaLancamentosIptuLogadoGov, {
          informacaoContribuinte: this.informacaoContribuinte,
        })
        .then((response) => {
          const retorno = response.data;

          const listaLancamentos = retorno[0];

          if (listaLancamentos === null || listaLancamentos.length < 1) {
            this.mensagemErro.push("Não foram encontradas DRAM's de IPTU para o índice cadastral informado.")
          }
          else {
            this.listaGuiasIptu = listaLancamentos;
            this.verificaGuiaUnica(this.listaGuiasIptu);
            this.mostrarDemaisInformacoes = true;
            posicionaPagina("#ancora-dram-iptu");
          }


          if (listaLancamentos.MENSAGEM_RETORNO === "OK") {
            this.mostrarSelecaoLancamentos = true;
            this.mostrarSelecaoDebitos = true;
            this.listaAgrupamentos = [];

            const lancamentos = [];

            listaLancamentos.LISTA_AGRUPAMENTO.map((lancamento) =>
              lancamentos.push(lancamento)
            );

            this.listaAgrupamentos = lancamentos;

            this.listaNiveis = this.montaAgrupamento(lancamentos);
          }

          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    verificaGuiaUnica: function(lista) {
        const novaLista = lista.filter(item => item.AINDICECADASTRAL !== null); 
        if (novaLista.length !== 1) return;  
        // Só segue se houver exatamente 1 registro
        if (novaLista[0].ASITUACAOINDICE === 'EM ATRASO'|| novaLista[0].ASITUACAOINDICE === 'ATIVO')
            this.guiaPagamentoAVista(novaLista[0].AURLEMISSAO);
    },

    pesquisarIptu: async function () {
      this.mostrarDemaisInformacoes = false;
      // this.endereco.codigoNacional = this.endereco.codigoNacional;
      this.exibirIndicesCadastraisParaSelecionarIptu = false;
      this.mensagemErro = [];

      if (this.endereco.cep && this.endereco.codigoNacional) {
        this.retornaIndicesCadastraisPorEndereco();
      } else if (this.informacaoContribuinte.indiceCadastral) {
        this.lancamentosAgrupados();
      } else {
        this.mensagemErro.push("É necessário informar um Índice Cadastral ou um CEP e CPF/CNPJ válidos.");
        window.scrollTo(0, 0); 
      }
    },

    limparFormulario: function () {
      this.limparMensagensDeErro();
      this.mostrarDemaisInformacoes = false;
      this.exibirIndicesCadastraisParaSelecionarIptu = false;
      this.informacaoContribuinte = {};
      this.limparEndereco();
      this.cadastroNacional = "";
      this.endereco.codigoNacional = "";
    },

    buscarIdPessoaPorCodigoNacional: async function () {
      this.mensagemErro = [];
      this.carregando = true;

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarIdPessoaPorCodigoNacional, {
          codigoNacional: this.codigoNacional,
        })
        .then((response) => {
          const retorno = response.data;
          let idPessoa = retorno[0].ID_PESSOA;
          this.informacaoContribuinte.idPessoa = idPessoa;
          this.informacaoContribuinte.nome = retorno[0].NOME;

          this.lancamentosAgrupadosLogadoGov();

          if (this.informacaoContribuinte.idPessoa == null || this.informacaoContribuinte.idPessoa == "") {
            this.mensagemErro.push("Não foi pessoa para o cpf/cnpj informado.")
          }
        })
        .catch((err) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    buscarEndereco: async function () {
      this.mensagemErro = [];

      if (this.endereco.cep) {       
        await this.$axios
          .post(this.$env.url_backend + constantes.buscarEndereco, {
            endereco: this.endereco,
          })
          .then((response) => {
            const retorno = response.data;
            const logradouro = retorno[0];

            this.carregando = false;
            this.carregandoTabelaLancamentos = false;
            if (logradouro != null) {
              this.endereco.tipologradouro = logradouro.TIPO_LOGRADOURO;
              this.endereco.logradouro = logradouro.TIPO_LOGRADOURO + " " + logradouro.NOME_OFICIAL;
              this.erroValidacaoCep = "text-success";
              this.mensagemValidacaoCep = "CEP digitado é válido";
              this.preencheCepOK = true;
            } else {
              this.mensagemValidacaoCep = "Não foi encontrado logradouro para o cep informado.";
              this.erroValidacaoCep = "text-danger";
              this.preencheCepOK = false;
              this.endereco.logradouro = "";
            }
          })
          .catch((err) => {
            this.carregando = false;
            this.carregandoTabelaLancamentos = false;
            const mensagem = normalizaMensagemApi(err);
            this.mensagemErro.push(mensagem);
            window.scrollTo(0, 0);
          });
      }
    },

    emiteCND: function (url) {
      this.downloadArquivo(url, "emissaoCND");
    },

    buscarEnderecoComBairro: async function () {
      this.mensagemErro = [];

      if (this.endereco.cep) {
        await this.$axios
          .post(this.$env.url_backend + constantes.buscarEnderecoComBairro, {
            endereco: this.endereco,
          })
          .then((response) => {
            const retorno = response.data;

            const logradouro = retorno[0];

            if (logradouro != null) {

              this.endereco.tipologradouro = logradouro.TIPO_LOGRADOURO;
              this.endereco.logradouro = logradouro.NOME_OFICIAL;
              this.endereco.bairro = logradouro.NOME_BAIRRO_INICIAL;
            } else {
              this.mensagemErro.push("O cep e o número informado são incompatíveis.")
            }

            this.carregando = false;
            this.carregandoTabelaLancamentos = false;
          })
          .catch((err) => {
            this.carregando = false;
            this.carregandoTabelaLancamentos = false;
            const mensagem = normalizaMensagemApi(err);
            this.mensagemErro.push(mensagem);
            window.scrollTo(0, 0);
          });
      }
    },

    retornaIndicesCadastraisPorEndereco: async function () {
      this.carregandoTabelaLancamentos = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.mensagemErro = [];
      this.listaGuiasIptu = [];
      this.carregando = true;

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaIndicesCadastraisPorEndereco, {
          endereco: this.endereco,
        })
        .then((response) => {
          const retorno = response.data;         
          this.listaIndicesCadastraisParaSelecionar = retorno[0];
          if (this.listaIndicesCadastraisParaSelecionar === null) {
            this.mensagemErro.push("Não foram encontrados índices cadastrais para os dados de endereço informados.");
            window.scrollTo(0, 0);
          }
          else {
            this.verificaGuiaUnica(this.listaIndicesCadastraisParaSelecionar);
            this.exibirIndicesCadastraisParaSelecionarIptu = true;
             posicionaPagina("#ancora-selecao-indice-cadastrais");
          }

          this.carregando = false;
        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },


    retornaCalculos: async function () {
      this.carregando = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];

      this.mensagemErro = [];
      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const agrupamento = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.AGRUPAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaCalculos, {
          lancamentosSelecionados: lancamentos,
          agrupamentoSelecionados: agrupamento,
          usuario: this.userName,
        })
        .then((response) => {
          const retorno = response.data;
          const calculosRetornados = retorno[0];
          this.calculos = calculosRetornados;

          if (this.calculos.TLISTAURLGUIA === null)
            this.mensagemErro.push(`Falha ao gerar DRAM. Favor entrar em contato pelo e-mail gecda@pbh.gov.br`);
          else {
            this.exibirListaGuia = true;
          }
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
        });

      this.carregando = false;
    },

    retornaCalculosParcelar: async function () {
      this.carregando = true;
      this.mensagemErro = [];

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.CODIGO_LANCAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaCalculosParcelar, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;

          if (retorno[0].length == 10)
            this.mensagemErro.push(
              `Não encontrou dados para o lançamento selecionado`
            );
          else {
            this.opcoesParcelamento = [
              {
                descricao_grupo: "IPTU",
                lista_lancamento: "13001220246874",
                lista_opcao_parcto: [
                  {
                    APercDepositoInicial: 50,
                    AVlrDepositoInicial: 125.65,
                    AQtdParcela: 23,
                    AQtdParcelaHonorario: 28,
                    AVlrParcela: 3354.67,
                    AVlrParcelaHonorario: 222.33,
                    AVlrdesconto: 34.55,
                    AIdTipoParcelamento: 3,
                    AIdRegraParcelamento: 3343,
                    AIdFaixasRegraParcelamento: 1234343,
                    adescricao: "teste teste teste",
                  },
                  {
                    APercDepositoInicial: 50,
                    AVlrDepositoInicial: 500.45,
                    AQtdParcela: 12,
                    AQtdParcelaHonorario: 28,
                    AVlrParcela: 679.90,
                    AVlrParcelaHonorario: 222.33,
                    AVlrdesconto: 34.55,
                    AIdTipoParcelamento: 3,
                    AIdRegraParcelamento: 3343,
                    AIdFaixasRegraParcelamento: 1234343,
                    adescricao: "teste teste teste",
                  },
                  {
                    APercDepositoInicial: 50,
                    AVlrDepositoInicial: 45.90,
                    AQtdParcela: 5,
                    AQtdParcelaHonorario: 28,
                    AVlrParcela: 1204.56,
                    AVlrParcelaHonorario: 222.33,
                    AVlrdesconto: 34.55,
                    AIdTipoParcelamento: 3,
                    AIdRegraParcelamento: 3343,
                    AIdFaixasRegraParcelamento: 1234343,
                    adescricao: "teste teste teste",
                  },
                ],
              },
              {
                descricao_grupo: "PARCELAMENTOS ATIVOS",
                lista_lancamento: "13001170454364",
                lista_opcao_parcto: [
                  {
                    APercDepositoInicial: 23,
                    AVlrDepositoInicial: 400.34,
                    AQtdParcela: 14,
                    AQtdParcelaHonorario: 18,
                    AVlrParcela: 5045.89,
                    AVlrParcelaHonorario: 224.33,
                    AVlrdesconto: 24.55,
                    AIdTipoParcelamento: 2,
                    AIdRegraParcelamento: 4546,
                    AIdFaixasRegraParcelamento: 232434564,
                    adescricao: "parcelamento teste",
                  },
                  {
                    APercDepositoInicial: 43,
                    AVlrDepositoInicial: 978.90,
                    AQtdParcela: 32,
                    AQtdParcelaHonorario: 18,
                    AVlrParcela: 3500.80,
                    AVlrParcelaHonorario: 224.33,
                    AVlrdesconto: 24.55,
                    AIdTipoParcelamento: 2,
                    AIdRegraParcelamento: 4546,
                    AIdFaixasRegraParcelamento: 232434564,
                    adescricao: "parcelamento teste",
                  },
                  {
                    APercDepositoInicial: 23,
                    AVlrDepositoInicial: 680.00,
                    AQtdParcela: 10,
                    AQtdParcelaHonorario: 18,
                    AVlrParcela: 2300.50,
                    AVlrParcelaHonorario: 224.33,
                    AVlrdesconto: 24.55,
                    AIdTipoParcelamento: 2,
                    AIdRegraParcelamento: 4546,
                    AIdFaixasRegraParcelamento: 232434564,
                    adescricao: "parcelamento teste",
                  },
                ],
              },
            ];
            this.exibirListaGuiaParcelar = true;
          }
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
        });

      this.carregando = false;
    },

    enviarMensagemEmissaoGuiaParcelamento: async function () {
      this.mensagemEmissaoGuiaSucesso = [];
      this.mensagemEmissaoGuia = [];
      const telefone = this.informacoesEmissaoGuia.telefoneCelular;
      const codigoEmissaoGuia = this.informacoesEmissaoGuia.confirmacao;

      const informacaoEmissaoGuia = { telefone, codigoEmissaoGuia };

      await this.$axios
        .post(
          this.$env.url_backend +
          constantes.enviarSMSEmissaoGuiaParcelamento,
          {
            informacaoEmissaoGuia,
          }
        )
        .then(() => {
          this.mensagemEmissaoGuiaSucesso.push("SMS enviado com sucesso!");
          this.mostrarConfirmacaoEmissaoGuia = true;
          this.informacoesEmissaoGuia.telefoneEnviado = true;
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.telefoneEnviado = false;
        });
    },

    enviarEmailEmissaoGuiaParcelamento: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      const email = this.informacoesEmissaoGuia.email;
      const codigoEmissaoGuia = this.informacoesEmissaoGuia.confirmacao;

      const informacaoEmissaoGuia = { email, codigoEmissaoGuia };

      await this.$axios
        .post(
          this.$env.url_backend +
          constantes.enviarEmailEmissaoGuiaParcelamento,
          {
            informacaoEmissaoGuia,
          }
        )
        .then(() => {
          this.mensagemEmissaoGuiaSucesso.push("E-mail enviado com sucesso!");
          this.mostrarConfirmacaoEmissaoGuia = true;
          this.informacoesEmissaoGuia.emailEnviado = true;
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });
    },

    emitirGuiaParcelamento: async function () {
      this.mensagemParcelamento = [];

      const email = this.informacaoParcelamento.email;
      const telefone = this.informacaoParcelamento.telefone;

      const opcaoParctoInternaSelecionada =
        this.escolhaOpcaoParcelamentoInterna;

      if (opcaoParctoInternaSelecionada) {
        const lancamentos = this.lancamentosSelecionados.map(
          (lancamento) => lancamento.ID_LANCAMENTO
        );

        const informacaoGuia = {
          lancamentos,
          email,
          telefone,
          idOperadorSistema: 0,
          selecao: opcaoParctoInternaSelecionada,
        };

        this.guiaParcelamento(informacaoGuia);
      }
    },

    limparCamposEmissaoGuia: function () {
      this.informacoesEmissaoGuia.listaParcelamento = [];

      this.informacoesEmissaoGuia.cpfCnpj = "";
      this.informacoesEmissaoGuia.razaoSocial = "";
      this.informacoesEmissaoGuia.telefoneCelular = "";
      this.informacoesEmissaoGuia.telefoneEnviado = false;
      this.informacoesEmissaoGuia.email = "";
      this.informacoesEmissaoGuia.emailEnviado = false;
      this.mensagemLancamentos = [];
      this.mostrarConfirmacaoEmissaoGuia = false;
      this.informacoesEmissaoGuia.codigoEmissaoGuia = "";

      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
    },

    confirmarEmissaoGuia: async function () {
      this.carregando = true;
      this.mensagemEmissaoGuia = [];

      const lancamentosEmissaoGuia = this.lancamentosEmissaoGuia.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const informacaoEmissaoGuia = { lancamentosEmissaoGuia };

      await this.$axios
        .post(this.$env.url_backend + constantes.confirmarEmissaoGuia, {
          informacaoEmissaoGuia,
        })
        .then((response) => {
          const retorno = response.data[0];

          this.informacoesEmissaoGuia.cpfCnpj =
            this.informacaoContribuinte.cadastroNacional;

          this.informacoesEmissaoGuia.razaoSocial =
            this.informacaoContribuinte.nome;

          if (retorno.AMENSAGEM === "OK") {
            this.informacoesEmissaoGuia.confirmacao = retorno.ACONFIRMACAO;
            this.informacoesEmissaoGuia.dadosExibicao = retorno.ADADOSEXIBICAO;
            this.informacoesEmissaoGuia.listaParcelamento =
              retorno.ALISTAPARCTOS;
            this.carregando = false;
          } else {
            this.mensagemEmissaoGuia.push(response.data.AMENSAGEM);
            this.carregando = false;
          }
        })
        .catch(() => {
          this.carregando = false;
          this.mostrarConfirmacaoEmissaoGuia = false;
        });
    },

    finalizarEmissaoGuia: async function () {
      this.mensagemEmissaoGuia = [];
      this.bloquearExibirLancamentos = false;
      if (
        this.informacoesEmissaoGuia.codigoEmissaoGuia ===
        this.informacoesEmissaoGuia.confirmacao
      ) {
        this.fecharModal("modal-EmissaoGuia");
        this.bloqueioEmissaoGuia = false;
        this.bloquearExibirLancamentos = true;
        await this.retornaCalculos();
      } else {
        this.bloqueioEmissaoGuia = true;
        this.mensagemEmissaoGuia.push("O código inserido está incorreto.");
      }
    },

    guiaParcelamento: async function (informacaoGuia) {
      this.mensagemParcelamento = [];
      this.carregando = true;
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaGuiaParcelamentos, {
          informacaoGuia,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].AMENSAGEM === "OK") {
            const url = retorno[0].AURLEMISSAO;

            this.downloadArquivo(url, "emissaoDRAM");
            this.carregando = false;
          } else {
            this.mensagemParcelamento.push(
              "Houve um erro ao gerar o DRAM de parcelamento."
            );
            this.carregando = false;
          }
        })
        .catch((err) => {
          this.carregando = false;
          this.fecharModal("modal-parcelamento");
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemParcelamento.push(mensagem);
        });
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl)

    },

    simularPagamento: async function () {
      this.mensagemErro = [];

      this.carregando = true;

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.imprimeSimulacao, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const url = retorno[0];
          const link = url;

          this.downloadArquivo(link, "emissaoDRAM");
          this.carregando = false;
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          this.fecharModal("modal-lancamentos");
          window.scrollTo(0, 0);
          this.carregando = false;
        });
    },

    guiaPagamentoAVista(url) {
      this.downloadArquivo(url, "emissaoDRAM");
    },

    limparDadosTabela: function () {
      this.limparInformacoesTabela();
      this.lancamentosSelecionados = [];
      this.lancamentosEmissaoGuia = [];
      this.lancamentos = [];
      this.calculos = {};

      this.orgaoCobranca.map((orgao) => {
        orgao.ALANCAMENTOS.map((lancamento) => {
          this.lancamentos.push(lancamento);
        });
      });
    },

    limparInformacoesTabela: function () {
      this.permitirCancelar = false;
      this.bloqueioEmissaoGuia = false;
    },

    formatDateTime: function (value) {
      if (!value) return "";
      else return moment(String(value)).format("DD/MM/YYYY");
    },

    formatCurrency: function (value) {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },


    verificaPreenchimento() {
      let opc = false;
      if (this.preencheIptuOK || this.preencheCpfCnpjOK && this.preencheCepOK) {
        opc = true;
      }
      return !opc;
    },

    formatCPFCNPJ(value) {
      if (value === "0") return "Identificador não encontrado";
      if (!value) return "";
      else {
        value = value.replace(/[^\d]+/g, "");

        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
          return value;
        } else if (value.length === 14) {
          value = value.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
            "$1.$2.$3/$4-$5"
          );
          return value;
        }
      }
    },

    apagaIdentificador: function () {
      this.dadosContribuinte.identificador = "";
      this.mascaraIdentificador = {};
      this.habilitarCampos();
    },

    getDebitosSelecionados(data) {
      data.map((item) => console.log(item));
      this.limparDadosTabela();
      this.lancamentos = [];
      this.calculos = {};

      this.orgaoCobranca.map((orgao) => {
        orgao.ALANCAMENTOS.map((lancamento) => {
          this.lancamentos.push(lancamento);
        });
      });
    },

    getSelecionados(data) {
      if (data.title === "indicesCadastraisIptu")
        this.listaIndicesCadastraisSelecionados = data.selecionados;
    },

    desabilitarCampos() {
      if (this.endereco.codigoNacional.length > 0) {
        this.dadosContribuinte.numeroParcelamento = "";
        this.dadosContribuinte.identificador = "";
        this.dadosContribuinte.tipoIdentificador = 0;

        this.desabilitaParcelamento = true;
        this.desabilitaIdentificador = true;
      } else if (this.dadosContribuinte.identificador.length > 0) {
        this.dadosContribuinte.numeroParcelamento = "";
        this.endereco.codigoNacional = "";

        this.desabilitaParcelamento = true;
        this.desabilitacodigoNacional = true;
        this.desabilitanomeContribuinte = true;
      } else if (this.dadosContribuinte.numeroParcelamento.length > 0) {
        this.endereco.codigoNacional = "";
        this.dadosContribuinte.tipoIdentificador = 0;
        this.dadosContribuinte.identificador = "";

        this.desabilitacodigoNacional = true;
        this.desabilitanomeContribuinte = true;
        this.desabilitaIdentificador = true;
      } else {
        this.habilitarCampos();
      }
    },

    habilitarCampos() {
      this.desabilitacodigoNacional = false;
      this.desabilitanomeContribuinte = false;
      this.desabilitaIdentificador = false;
      this.desabilitaParcelamento = false;
      this.bloquearExibirLancamentos = false;
    },

    limparMensagensDeErro() {
      this.mensagemErro = [];
      this.mensagemLancamentos = [];

      this.mensagemParcelamento = [];

      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoCPFCNPJ = "";

      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoIdentificador = "";

      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoParcelamento = "";

      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";

      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";

      this.erroValidacaoLancamento = "";
      this.mensagemValidacaoLancamento = "";
    },

    limparCamposParcelamento: function () {
      this.mensagemParcelamento = [];

      this.escolhaDemaisParcelamentos = "";
      this.mostrarDemais = false;

      this.escolhaCessao = "";
      this.mostrarCessao = false;

      this.informacaoParcelamento.email = "";
      this.informacaoParcelamento.telefone = "";
      this.bloquearExibirLancamentos = false;
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    preencheCep: function () {

    },

    preencheIPTU: function () {
      let tam = 0;
      let mensIPTU = "";
      let textColor = "";
      let opcao = "";
      this.limparEndereco();

      this.exibeBtnPesquisar = true;
      this.mensagemValidacaoIPTU = "";

      if (this.informacaoContribuinte.indiceCadastral.length > 0) {
        //INDICE CADASTRAL
        tam = 19;
        opcao = "ÍNDICE CADASTRAL";

        mensIPTU =
          this.informacaoContribuinte.indiceCadastral.length >= tam
            ? opcao + " digitado é válido"
            : opcao + " digitado está incompleto";

        textColor =
          this.informacaoContribuinte.indiceCadastral.length >= tam
            ? "text-success"
            : "text-danger";
        this.preencheIptuOK =
          this.informacaoContribuinte.indiceCadastral.length >= tam;
        if (this.informacaoContribuinte.indiceCadastral.length >= tam) {
          // indice cadastral
          if (this.validarIPTU(this.informacaoContribuinte.indiceCadastral)) {
            mensIPTU = opcao + " digitado(a) é válido(a)";
            textColor = "text-success";
            this.preencheIptuOK = true;
          } else {
            mensIPTU = opcao + " - dígito verificador inválido";
            textColor = "text-danger";
            this.preencheIptuOK = false;
          }
        }

        this.desabilitarCampos();

        this.erroValidacaoIptu = textColor;
        this.mensagemValidacaoIptu = mensIPTU;
      }
    },

    retornoNumeroCorrespondente: function (val) {
      let letra = val.toUpperCase();

      if (letra === " ") return 0;
      else if (letra == "A" || letra == "J") return 1;
      else if (letra == "B" || letra == "K" || letra == "S") return 2;
      else if (letra == "C" || letra == "L" || letra == "T") return 3;
      else if (letra == "D" || letra == "M" || letra == "U") return 4;
      else if (letra == "E" || letra == "N" || letra == "V") return 5;
      else if (letra == "F" || letra == "O" || letra == "W") return 6;
      else if (letra == "G" || letra == "P" || letra == "X") return 7;
      else if (letra == "H" || letra == "Q" || letra == "Y") return 8;
      else if (letra == "I" || letra == "R" || letra == "Z") return 9;
      else return parseInt(letra);
    },

    validarIPTU: function (iptu) {
      iptu = iptu.replace(/[^\d \w]+/g, "").trim();

      if (iptu.length !== 15) return false;

      iptu = iptu.split("");
      const valores = [3, 2, 7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      const posicoes = [6, 10, 11];

      let soma = 0;

      for (let index = 0; index < valores.length; index++) {
        let digito = iptu[index];
        if (posicoes.includes(index)) {
          soma += this.retornoNumeroCorrespondente(digito) * valores[index];
        } else {
          soma += digito * valores[index];
        }
      }
      const resto = soma % 11;
      let ultimoDigito = "";
      if (resto === 0) {
        ultimoDigito = "X";
      } else if (resto === 1) {
        ultimoDigito = "0";
      } else {
        ultimoDigito = 11 - resto;
      }
      return iptu[14] === ultimoDigito.toString();
    },

    validacaoIndiceCadastral: function () {
      let erro = "";
      let textColor = "";

      // INDICE CADASTRAL
      this.mascaraIdentificador = {
        mask: "###.###E.###E.X##.J",
        tokens: this.tokens,
      };

      this.desabilitarCampos();
      this.erroValidacaoIdentificador = textColor;
      this.mensagemValidacaoIdentificador = erro;
    },


    validacaoIdentificador: function () {
      let erro = "";
      let textColor = "";


      if (this.dadosContribuinte.tipoIdentificador === 1) {
        //inscrição municipal
        this.mascaraIdentificador = {
          mask: "#.###.###/###-J",
          tokens: this.tokens,
        };

      }

      if (this.dadosContribuinte.tipoIdentificador === 3) {
        // CPF
        this.mascaraIdentificador = {
          mask: "###.###.###-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 4) {
        // CNPJ
        this.mascaraIdentificador = {
          mask: "##.###.###/####-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 5) {
        // PERPETUIDADE
        this.mascaraIdentificador = {
          mask: "##############",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 14) {
        // PARCELAMENTO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 8) {
        // INDICE CADASTRAL
        this.mascaraIdentificador = {
          mask: "###.###E.###E.X##.J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 10) {
        // PLACA DE VEICULO
        this.mascaraIdentificador = {
          mask: "XXXXXXX",
          tokens: this.tokens,
        };
      }

      this.desabilitarCampos();
      this.erroValidacaoIdentificador = textColor;
      this.mensagemValidacaoIdentificador = erro;
    },


    limparEndereco() {
      this.endereco.cep = "";
      this.endereco.tipologradouro = "";
      this.endereco.logradouro = "";
      this.endereco.numero = "";
      this.endereco.complemento = "";
      this.endereco.bairro = "";
      this.endereco.codigoNacional = "";

      this.mensagemValidacaoCep = "";
      this.mensagemValidacaoCPFCNPJ = "";
    },

    limpaCepCodigoNacional: function () {
      this.mensagemValidacaoCep = "";
      this.limparEndereco();
      this.preencheCepOK = false;
      this.mensagemValidacaoCpfCnpj = "";
      this.preencheCpfCnpjOK = false;
    },

    limpaIPTU: function () {
      this.mensagemValidacaoIPTU = "";
      this.informacaoContribuinte.indiceCadastral = "";
      this.preencheIptuOK = false;
    },

    validacaoCEP: function () {
      this.limpaIPTU();

      this.preencheCepOK = false;

      let mensCEP = "";
      let textColor = "";
      let opcao = "";

      this.exibeBtnPesquisar = true;
      this.mensagemValidacaoCep = "";

      if (this.endereco.cep.length > 0) {
        //CEP
        const tam = 10;
        opcao = "CEP";

        mensCEP =
          this.endereco.cep.length >= tam
            ? opcao + " digitado é válido"
            : opcao + " digitado está incompleto";

        textColor =
          this.endereco.cep.length >= tam
            ? "text-success"
            : "text-danger";
        this.preencheCepOK =
          this.endereco.cep.length >= tam;

        if (this.endereco.cep.length >= tam) {
          this.buscarEndereco();
        }
        this.desabilitarCampos();

        this.erroValidacaoCep = textColor;
        this.mensagemValidacaoCep = mensCEP;
      }
      //CEP

    },

    consisteCPFCNPJ() {
      this.limpaIPTU();
      this.validacaoCPFCNPJ();
    },

    validacaoParcelamento: function () {
      const anoAtual = new Date().getFullYear();
      const numeroParcelamento = this.dadosContribuinte.numeroParcelamento;
      const anoParcelamento = numeroParcelamento.substring(
        8,
        numeroParcelamento.length
      );

      let erro = "";
      let textColor = "";

      if (anoParcelamento > anoAtual) {
        erro =
          "O ano em que foi feito o parcelamento não pode ser maior que o ano atual";
        textColor = "text-danger";
      }

      this.desabilitarCampos();
      this.erroValidacaoParcelamento = textColor;
      this.mensagemValidacaoParcelamento = erro;
    },

    validacaoCodigoParcelamento: function () {
      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";
    },

    validacaoPlacaVeiculo: function () {
      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";
    },

    validacaoLancamento: function () {
      this.erroValidacaoLancamento = "";
      this.mensagemValidacaoLancamento = "";
    },

    limparCampos: function () {
      this.limparMensagensDeErro();

      this.dadosContribuinte.nomeContribuinte = "";
      this.dadosContribuinte.cpf = "";

      this.mostrarDemaisInformacoes = false;
      this.mostrarErroMuitosLancamentos = false;
      this.dadosContribuinte.razaoSocial = "";
      this.dadosContribuinte.tipoIdentificador = 0;
      this.endereco.codigoNacional = "";
      this.dadosContribuinte.identificador = "";
      this.dadosContribuinte.numeroParcelamento = "";
      this.mostrarSelecaoDebitos = false;
      this.exibirDebitos = false;
      this.exibirListaGuia = false;
      this.exibeBotaoPesquisar = false;

      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.habilitarCampos();
    },

    abrirModalPagamentoAVistaSeNecessario: function (referencia) {
      if (this.calculos.TLISTAURLGUIA) this.$refs[referencia].show();
    },

    mostrarModalParcelamento: function () {
      if (
        this.calculos.OPCOES_PARCTO_CESSAO &&
        this.calculos.OPCOES_PARCTO_DEMAIS
      )
        this.$refs["modal-confirmar-parcelamento"].show();
      else {
        if (this.calculos.OPCOES_PARCTO_CESSAO)
          this.abrirModalParcelamentoSeNecessario("cessao");
        else this.abrirModalParcelamentoSeNecessario("demais");
      }
    },

    abrirModalParcelamentoSeNecessario: function (tipoLancamento) {
      this.fecharModal("dialog-confirmar-parcelamento");

      if (tipoLancamento === "cessao") {
        this.mostrarCessao = true;
        this.mostrarDemais = false;
        this.$refs["modal-parcelamento"].show();
      }

      if (tipoLancamento === "demais") {
        this.mostrarCessao = false;
        this.mostrarDemais = true;
        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirModalParcelamento: function (opcao) {
      this.opcaoParctoSelecionada = opcao;
      if (opcao.LISTA_OPCAO_PARCTO) {
        opcao.LISTA_OPCAO_PARCTO.map((calculo) => {
          this.listaOpcoesParcelamentoInternas.push({
            text: `Entrada de ${this.formatCurrency(
              calculo.AVLRDEPOSITOINICIAL
            )} + ${calculo.AQTDPARCELA} parcela(s) de ${this.formatCurrency(
              calculo.AVLRPARCELA
            )} (Desconto de ${calculo.APERCDEPOSITOINICIAL}%)`,
            value: calculo,
            disabled: false,
            hidden: false,
          });
        });

        this.listaDemaisParcelamentos.unshift({
          text: "Clique aqui para selecionar uma opção de parcelamento",
          value: "",
          selected: true,
          disabled: true,
          hidden: true,
        });

        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirDialogPagamentoAVista() {
      this.abrirModalPagamentoAVistaSeNecessario("modal-pagamento-a-vista");
    },

    abrirDialogParcelamento: async function () {
      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaOpcoesParcto, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const opcoesParctoRetorno = retorno[0];
          this.opcoesParcto = opcoesParctoRetorno;
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemParcelamento.push(mensagem);
        });

      if (this.opcoesParcto === null)
        this.mensagemParcelamento.push(
          "Não foram encontradas opções de parcelamento."
        );
      else this.$refs["modal-selecao-parcelamento"].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    retirarMensagensTela: function () {
      this.mensagemSucesso = [];
      this.mensagemErro = [];
      this.mensagemLancamentos = [];
      this.mensagemParcelamento = [];
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];

      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";

      this.mensagemValidacaoIdentificador = "";
      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoParcelamento = "";
      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";
      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoPlacaVeiculo = "";
      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoLancamento = "";
      this.erroValidacaoLancamento = "";
    },

    habilitaSelecaoDebitos() {
      this.mostrarSelecaoDebitos = false;
      this.exibirDebitos = true;
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
    },

    fecharGuiasParcelar() {
      this.exibirListaGuiaParcelar = false;
      this.opcaoParcelaSelecionada = null;
    },

    pagarVista() {
      this.exibirListaGuia = false;
      this.exibirListaGuiaParcelar = false;
      this.retornaCalculos();
    },

    parcelar() {
      this.exibirListaGuiaParcelar = false;
      this.exibirListaGuia = false;
      this.retornaCalculosParcelar();
    },

    retornaSelecaoDebitos() {
      this.novaPesquisa = "N";
      this.mostrarSelecaoDebitos = true;
      this.exibirDebitos = false;
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
    },

    mostrarDebitosSelecionados() {
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
      this.exibirDebitosSelecionados = true;
    },

    fecharDebitosSelecionados() {
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = true;
      this.verLancamentos = true;
    },

    onClose() {
      this.popoverShow = false;
    },
    async onOk() {

      this.informacaoContribuinte.indiceCadastral = this.listaIndicesCadastraisSelecionados[0].AINDICECADASTRAL;

      this.carregando = true;

      this.informnacaoContribuinte.usuario = this.origem;

      this.informacaoContribuinte.idPessoa = this.informacaoContribuinte.idPessoa || null;
      this.informacaoContribuinte.idPessoaPapel = this.informacaoContribuinte.idPessoaPapel || null;
      this.informacaoContribuinte.idParcelamento = this.informacaoContribuinte.idParcelamento || null;

      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaLancamentosIptu, {
          informacaoContribuinte: this.informacaoContribuinte,
        })
        .then((response) => {
          const retorno = response.data;

          const listaLancamentos = retorno[0];

          this.listaGuiasIptu = listaLancamentos;

          this.guiaPagamentoAVista(this.listaGuiasIptu[0].AURLEMISSAO);

          this.carregando = false;

        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });

    },

    limparmensagemValidacao: function () {
      if (this.informacaoContribuinte.indiceCadastral == "" ||
        this.informacaoContribuinte.indiceCadastral == null) {
        this.mensagemValidacaoIptu = "";
      }
      if (this.endereco.cep == "" || this.endereco.cep == null) {
        this.mensagemValidacaoCep = "";
      }
      if (this.endereco.codigoNacional == "" || this.endereco.codigoNacional == null) {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    montaAgrupamento: function (lista) {
      let agrupamentos = [];
      lista.map(function (lancamento) {
        agrupamentos.push({
          nome: lancamento.DESCRICAO,
          selecionado: false,
          valor: lancamento.VALOR || null,
          subitems:
            lancamento.LISTA_NIVEL2?.map(function (subnivel) {
              return {
                valor: `${lancamento.DESCRICAO}.${subnivel.DESCRICAO}`,
                selecionado: false,
                ALANCAMENTOS: subnivel.ALANCAMENTOS,
                qtdlanctos: subnivel.AQTDLANCTOS,
                valoravista: subnivel.AVALORAVISTA,
                valordebito: subnivel.AVALORDEBITO,
                valordesconto: subnivel.AVALORDESCONTO,
                nome: subnivel.DESCRICAO,
              };
            }) || null,
        });
      });
      return agrupamentos;
    },

    toggleAll(checked) {
      this.selected = checked ? this.orgaoCobranca.slice() : [];
    },
  },

  watch: {

    opcaoCpfCnpjSelecionada() {
      this.endereco.codigoNacional = "";
      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";
      this.preencheCpfCnpjOK = false;
      this.mostrarInputCpfCnpj = false;
      this.$nextTick(() => {
          this.mostrarInputCpfCnpj = true;   //recria o input já com a nova máscara
          this.$nextTick(() => {
            this.focusInput("cpfCnpj");
           });
      });
    },

    'informacaoContribuinte.indiceCadastral'(newValue) {
      this.limparmensagemValidacao();
      if (newValue.length > 0) {
        this.preencheIPTU();
      }
    },

    'endereco.cep'(newValue) {
      this.limparmensagemValidacao();
      if (newValue.length > 0) {
        this.validacaoCEP();
      }
    },

    'endereco.codigoNacional'(valor) {
        this.validarDocumento(valor);
    },

    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.orgaoCobranca.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },

  computed: {

      configuracaoDocumento() {
        return this.opcaoCpfCnpjSelecionada === "CPF"
          ? {
              tipo: "CPF",
              tamanho: 14,
              mascara: "###.###.###-##",
              validar: validarCPF,
            }
          : {
              tipo: "CNPJ",
              tamanho: 18,
              mascara: "XX.XXX.XXX/XXXX-##",
              validar: validarCNPJ,
            };
      },

      mascaraCpfCnpj() {
        return {
          mask: this.configuracaoDocumento.mascara,
          tokens: this.tokens,
        };
      },

    anoAtual() {
      const UM_DIA = 86400000;
      const hoje = new Date();
      const proximoDia = new Date(hoje.getTime() + UM_DIA);

      return proximoDia.getFullYear();
    },
    rows() {
      return this.items.length;
    },
  },

  created() {
    this.origem = this.$store.getters.userInfo.origem;
    let codigoNacional = this.$store.getters.userInfo.preferred_username;

    if (this.origem == 'GovBr') {
      this.codigoNacional = codigoNacional;
      this.buscarIdPessoaPorCodigoNacional();
    }
  },
};
</script>

<style lang="css" scoped>
.container {
  min-width: 90%;
  max-width: 90%;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}

.botao {
  width: 150px;
  height: 80px;
}

hr {
  border-color: #aaa;
  box-sizing: border-box;
  width: 100%;
}
</style>
